import { AttendantListItem } from '@/zustand/interfaces/attendant-list-data';

export function filterAttendantsByStatus(attendants: AttendantListItem[]) {
  const active = attendants.filter((a) => a.enabled);
  const inactive = attendants.filter((a) => !a.enabled);
  return { active, inactive };
}
